'use client';

import { useState, useEffect } from 'react';
import { getUserData, setUserData } from '@/lib/auth';
import { CustomerModel, } from '../../models'
import { Lock, EyeOff, Eye, X, Check } from 'lucide-react';
import Loading from '@/components/Loading';

const customer_model = new CustomerModel()

export default function PromotionPage() {
  const [isLoading, setIsLoading] = useState(true);
  const [user, setUser] = useState<any>([]);
  const [old_password, setOldPassword] = useState('');
  const [new_password_1, setNewPassword1] = useState('');
  const [new_password_2, setNewPassword2] = useState('');
  const [showPassword1, setShowPassword1] = useState(false);
  const [showPassword2, setShowPassword2] = useState(false);
  const [showPassword3, setShowPassword3] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const [check_alphabet, setAlphabet] = useState(false);
  const [check_number, setNumber] = useState(false);
  const [check_length, setLength] = useState(false);
  const [check_alphanumeric, setAlphaNumeric] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const userData = await getUserData();
        if (userData) await setUser(userData);
        setIsLoading(false);
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    })()
  }, []);

  const checkSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setSuccess('');
    setError('');
    
    if(old_password !== user.customer_password){
      setError('รหัสผ่านเก่าไม่ถูกต้อง');
    } else if(!check_length){
      setError('รหัสผ่านใหม่ต้องมีความยาวอย่างน้อย 8 ตัวอักษร (สูงสุด 20 ตัว) ');
    } else if(!check_alphabet){
      setError('รหัสผ่านใหม่ต้องมีตัวอักษรอย่างน้อย 1 ตัว');
    } else if(!check_number){
      setError('รหัสผ่านใหม่ต้องมีตัวเลขอย่างน้อย 1 ตัว');
    } else if(!check_alphanumeric){
      setError('รหัสผ่านต้องเป็นตัวอักษร a-z, A-Z และตัวเลข 0-9 เท่านั้น');
    } else  if(new_password_1 !== new_password_2){
      setError('รหัสผ่านใหม่ทั้งสองครั้งไม่ตรงกัน');
    } else if(old_password === new_password_2){
      setError('รหัสผ่านใหม่ต้องไม่เหมือนรหัสผ่านเก่า');
    }else{
      try {
        await customer_model.updateCustomerPassword({ customer_code: user.customer_code, customer_password: new_password_2 });
        const customer = await customer_model.getCustomerByCode({ customer_code: user.customer_code, })
    
        if (customer) {
          await setUser(customer);
          await setUserData(customer);
          setOldPassword('');
          setNewPassword1('');
          setNewPassword2('');
          setSuccess('เปลี่ยนรหัสผ่านสำเร็จ');
        }
      } catch (error) {
        setError('เกิดข้อผิดพลาดในการเปลี่ยนรหัสผ่าน');
        console.error('Error updating password:', error);
      }
    } 
    
    setIsLoading(false);
  };

  const checkPassword = async (password: string) => {
    const alphanumeric =/^[A-Za-z0-9]*$/gi.test(password);
    const alphabet = /[A-Za-z]+/.test(password);
    const number = /[0-9]+/.test(password);
    const length = password.length < 8 || password.length >= 20 ? false : true;
    
    setLength(length);
    setNumber(number);
    setAlphabet(alphabet);
    setAlphaNumeric(alphanumeric);
    setNewPassword1(password);
  };

  return (
    <div className="p-4 min-h-screen ">
      {isLoading ? <Loading /> : <>
        <div className="grid gap-3 h-[100%]">
          <div className="w-full flex-1 text-gray-500 flex-col min-h-[60vh]">
            <form onSubmit={checkSubmit} className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-700 mb-2">รหัสผ่านเก่า</label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    type={showPassword1 ? 'text' : 'password'}
                    value={old_password}
                    onChange={(e) => setOldPassword(e.target.value)}
                    placeholder="••••••••"
                    className="w-full pl-10 pr-12 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-400 focus:border-transparent outline-none"
                    required
                  />
                  <button type="button" onClick={() => setShowPassword1(!showPassword1)} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
                    {showPassword1 ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                  </button>
                </div>
              </div>
              
              <div className="mt-4">
                <label className="block text-sm font-semibold text-gray-700 mb-2">รหัสผ่านใหม่</label>
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    type={showPassword2 ? 'text' : 'password'}
                    value={new_password_1}
                    onChange={(e) => checkPassword(e.target.value)}
                    placeholder="••••••••"
                    className="w-full pl-10 pr-12 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-400 focus:border-transparent outline-none"
                    required
                  />
                  <button type="button" onClick={() => setShowPassword2(!showPassword2)} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
                    {showPassword2 ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                  </button>
                </div>
              </div>
              <div className="mt-2">
                <div className="relative">
                  <Lock className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 w-5 h-5" />
                  <input
                    type={showPassword3 ? 'text' : 'password'}
                    value={new_password_2}
                    onChange={(e) => setNewPassword2(e.target.value)}
                    placeholder="••••••••"
                    className="w-full pl-10 pr-12 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-green-400 focus:border-transparent outline-none"
                    required
                  />
                  <button type="button" onClick={() => setShowPassword3(!showPassword3)} className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600">
                    {showPassword3 ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
                  </button>
                </div>
              </div>
              
              <button type="submit" disabled={isLoading} className="mt-4 w-full bg-yellow-500 hover:bg-yellow-600 text-white font-semibold py-4 rounded-xl flex items-center justify-center gap-2 transition-all disabled:opacity-50 disabled:cursor-not-allowed">
                <Lock className="w-5 h-5" />
                {isLoading ? 'กำลังเปลี่ยนรหัสผ่าน...' : 'เปลี่ยนรหัสผ่าน'}
              </button>

              {error && (
                <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">{error}</div>
              )}
              {success && (
                <div className="bg-red-50 border border-green-200 text-green-700 px-4 py-3 rounded-lg text-sm">{success}</div>
              )}
              <div className="bg-white border border-blue-500 text-blue-700 px-4 py-3 rounded-lg text-sm flex flex-col">
                <div>รหัสผ่านของคุณจะต้องมีอักขระเหล่านี้เป็นอย่างน้อย:</div>
                <div className="flex">
                  {check_length ? <Check className='w-5 h-5 mr-1 text-green-500' />  : <X className='w-5 h-5 mr-1 text-red-500' /> }
                  อักขระ 8 ตัว (สูงสุด 20 ตัว) 
                </div>
                <div className="flex py-0" >
                  {check_alphabet ? <Check className='w-5 h-5 mr-1 text-green-500' />  : <X className='w-5 h-5 mr-1 text-red-500' /> }
                  ตัวอักษร อย่างน้อย 1 ตัว
                </div>
                <div className="flex" >
                  {check_number ? <Check className='w-5 h-5 mr-1 text-green-500' />  : <X className='w-5 h-5 mr-1 text-red-500' /> }
                  ตัวเลข อย่างน้อย 1 ตัว
                </div>
                <div className="flex" >
                  {check_alphanumeric ? <Check className='w-5 h-5 mr-1 text-green-500' />  : <X className='w-5 h-5 mr-1 text-red-500' /> }
                  รหัสผ่านต้องเป็นตัวอักษร a-z, A-Z และตัวเลข 0-9 เท่านั้น
                </div>
              </div>
            </form>
          </div>
        </div>
      </>}
    </div>
  );
}
